module.exports = __webpack_public_path__ + "static/media/hq2.ccaf5067.jpg";